import React from "react";
import { Dialog } from "@headlessui/react";
import { Separate } from "components/ui";
import { IMAGE_URL } from "config/Api";
import { useNavigate } from "react-router-dom";

interface Props {
  link: any;
  onClose: () => void;
}

const MultiDocumentView: React.FC<Props> = ({ link, onClose }) => {
  const navigate = useNavigate();

  const onVisitLink = (list: any) => {
    if (!link) return;
    const pdfFile = `${IMAGE_URL}${list.documentUrl}`;
    const encodedUrl = encodeURIComponent(pdfFile);
    onClose();

    navigate(`/pdfViewer?url=${encodedUrl}`);
  };

  return (
    <>
      <Dialog.Title
        as="h3"
        className="text-gray-900 pb-4 text-center text-xl font-medium leading-6"
      >
        {link.social_media_name}
      </Dialog.Title>
      <Separate dark={true} />
      <div className="px-4 py-8 sm:px-10 sm:py-10">
        <ul className="grid grid-cols-2 gap-6 sm:grid-cols-3">
          {link?.multiDocument.map((list: any, index: any) => {
            return (
              <li
                key={index}
                className={
                  "cursor-pointer select-none rounded-xl bg-white/10 py-3 px-2 backdrop-blur-md"
                }
                onClick={() => onVisitLink(list)}
              >
                <button
                  type="button"
                  className="rounded bg-gold py-3 px-5 text-sm font-medium leading-tight text-black"
                >
                  {list?.documentName}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default MultiDocumentView;
